<h4 mat-dialog-title>Редактирование категории</h4>
<app-close-button [formGroup]="categoryForm" [dialogRef]="dialogRef"/>
<mat-dialog-content>
    <app-loader [isLoading]="loading()"/>
    <form class="flex-column" [formGroup]="categoryForm" (ngSubmit)="onSubmit()">

        <mat-form-field appearance="fill">
            <mat-label>Название вида работ</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>CustomID</mat-label>
            <input matInput formControlName="customId" maxlength="100" />
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Имя таблицы оборудования</mat-label>
            <input matInput formControlName="equipmentExTableName" />
        </mat-form-field>

<!--            @if (authService.isAdmin()) {-->
<!--                <app-common-dropdown [label]="'Компания'" [service]="companySelectorService" [formCtrl]="categoryForm.controls.companyId"/>-->
<!--            }-->
        <div class="flex justify-between">
            <button mat-stroked-button class="w-40" color="basic" type="button" [disabled]="!category.data.id" (click)="deleteCategory(category.data.id)">Удалить</button>
            <button mat-flat-button class="w-40" color="primary" type="submit" [disabled]="!categoryForm.valid">Сохранить</button>
        </div>
    </form>
</mat-dialog-content>
